<template>
  <div v-if="overallValues" class="home" id="nsc" style="height:127px;">
    <div style="margin:0px 4px;">
      <table class="tbl-table">
        <thead>
          <tr class="tbl-tr tbl-bg">
            <td class="tbl-td tbl-cell" v-bind:style="{ width: getHeadWidth + '%' }"></td>
            <td class="tbl-td tbl-cell bold"
                v-bind:class="{ head15 : waveCount < 5, head10 : waveCount > 4, narrow: isCompetitionOverall }"
                v-for="(itm, index) in getSurveyWaves" :key='index'>{{ itm.PropertyValue }}</td>
          </tr>
        </thead>
        <tfoot>
          <tr class="tbl-tr tbl-bg">
            <td class="tbl-td tbl-cell left">{{$t('Webportal.DashboardBMW.Total')}}</td>
            <td class="tbl-td tbl-cell bold"
                v-for="(itm, index) in getSurveyWaves"
                :key="index">{{ GetItemValue(itm, 't') }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShopsOverall',

    props:[
      'overallValues',
      'isCompetitionOverall'
    ],

    methods: {
      GetItemValue(waveItem, iwot) {
        if (iwot === 't')
          if (waveItem.NumberOfShopsTotal) return waveItem.NumberOfShopsTotal;

        return "0";
      },

      hasWaves() {
        return this.overallValues && this.overallValues.SurveyWave && _.size(this.overallValues.SurveyWave) > 0
      },
    },

    computed: {
      getSurveyWaves: function() {
        let things = new Array();
        let i1 = _.find(this.overallValues.SurveyWave, ['PropertyValue', 'BMW M']);
        if (i1) things.push(i1)
        if (!this.isCompetitionOverall) {
          let i2 = _.find(this.overallValues.SurveyWave, ['PropertyValue', 'Competitors']);
          if (i2) things.push(i2)
        }

        let i3 = _.find(this.overallValues.SurveyWave, ['PropertyValue', 'AMG']);
        if (i3) things.push(i3)

        let i4 = _.find(this.overallValues.SurveyWave, ['PropertyValue', 'AUDI']);
        if (i4) things.push(i4)

        let i5 = _.find(this.overallValues.SurveyWave, ['PropertyValue', 'Porsche']);
        if (i5) things.push(i5)

        return things;
      },

      getHeadWidth: function() {
        let waves = this.waveCount
        if (waves < 5) return 100 - waves * 15
        return 100 - waves * 10
      },

      waveCount: function () {
        if (!this.hasWaves) return 0
        return this.overallValues.SurveyWave.length

        // return this.isCompetitionOverall ? _.size(this.overallValues.SurveyWave)-1 : _.size(this.overallValues.SurveyWave)
      },
    }
  }
</script>


<style scoped>
.narrow {
  letter-spacing: -0.15em;
}
.left{
  text-align: left;
}
.bold {
  font-weight: bold;
}
.head10 {
  width:10%;
}
.head40 {
  width:40%;
}

#nsc {
    float: right;
      /* position: relative; */
  /* top: 3px; */
  /* padding-bottom: 3px; */
  line-height: 1.1
}

.home {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  background: transparent;
}

</style>
